import React from 'react';
import Carousel from '../pages/Carousel';
import FeaturesSection from '../pages/FeaturesSection';
import FunFactsSection from '../pages/FunFactsSection';
import WhyChooseSection from '../pages/WhyChooseSection';
import Serviceshome from '../pages/Serviceshome';
import Testimonials from '../pages/Testimonialshome';
import Departments from '../pages/Departments';
import PricingTable from '../pages/PricingTable';
import Blog from '../pages/Blog';
import ClientsSlider from '../pages/ClientsSlider';
import Youtubehome from '../pages/Youtubevideos';


const HeroSection = () => {
  return (


    <div className="th-hero-wrapper hero-1" id="hero">


     
    <Carousel/>
    {/* <ScheduleSection/> */}
    <Youtubehome/>
    <FeaturesSection/>
    <FunFactsSection/>
    <WhyChooseSection/>
  
    {/* <CallToAction/> */}
    {/* <Portfolio/> */}
    <Serviceshome/>
    <Testimonials/>
    <Departments/>
    <PricingTable/>
    {/* <Team/> */}
    <Blog/>
    <ClientsSlider/>
      
    </div>
  );
};

export default HeroSection;
